module.exports = __webpack_public_path__ + "static/media/logo_screens.b1cbd3d6.png";